import cssVars from 'css-vars-ponyfill';

export const brandStyle = () => {
  const style = ({
    bodyFont = 'Takeaway Sans, sans-serif',
    bodyWeight = '400',
    headingFont = 'Takeaway Sans, sans-serif',
    headingWeight = '700',
    color1 = '#FF8000',
    bodyColor = '#0A3847',
  }) => {
    return cssVars({
      onlyVars: true,
      variables: {
        // user customizable styles
        '--body-font': bodyFont,
        '--body-weight': bodyWeight,
        '--heading-font': headingFont,
        '--heading-weight': headingWeight,
        '--color-1': color1,

        // developer convenient variables
        '--body-color': bodyColor,
      },
    });
  }

  let styling = style({});
  return styling;
}
